import type { FC } from 'react';

import type { IconProps } from './type';

export const UnCheckedIcon: FC<IconProps> = (props) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 12 11"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.1132 10.5494L5.99023 6.76073L9.86727 10.5494L11.375 9.076L7.49797 5.28737L11.375 1.49874L9.86727 0.0253906L5.99023 3.81402L2.1132 0.0253906L0.605469 1.49874L4.4825 5.28737L0.605469 9.076L2.1132 10.5494Z"
        fill="#EE3A70"
      />
    </svg>
  );
};
